<template>
    <div class="buy-and-download-container">
        <div class="buy-and-download">
            <router-link :to="{ name:'download-home'}" tag="button" class="download">{{$t('pages.main.intro.downloadButtonText')}}</router-link>
            <router-link :to="{ name:'pricing'}" tag="button" class="buy">{{$t('pages.main.intro.buyButton')}}</router-link>
        </div>
        <p><slot></slot></p>
    </div>
</template>

<script>

    export default {
        name: "DownloadOrBuyPanel"
    }
</script>


<style scoped lang="scss">
    @import "../theme/theme";

    .buy-and-download-container {
        display: grid;

        p {
            color:$primaryText100;
            margin-top: 0.5rem;
            font-weight: 300;
            font-size: 0.8rem;
        }
        .buy-and-download {
            button {
                user-select: none;
                padding: 0.7em 1em;
                border-radius: 0.4em;
                border-width: 1px;
                border-style: solid;
                text-decoration: none;
                text-effect: none;
                font-size: 1em;
                cursor: pointer;
                transition-duration: .25s;
                transition: all .25s;
                outline:none;
            }

            .download {
                background: $primary100;
                border-color: $back20;
                color: $primaryText100;
                margin-right: 0.5em;

                border-style: solid;
                min-width: 15em;
                outline:none;
            }

            .download:hover {
                background: $back20;
                border-color: $back20;
                color: $primary10;
            }

            .buy {
                background: $primary10;
                color: $back20;
                margin-top: 0.5em;
                border-color: $primary100;
                outline:none;

            }

            .buy:hover {
                border-color: $primary10;
            }
        }
    }
</style>